/** Unsplash-aware <img>: adds a responsive srcSet so phones download ~500px files instead of 1400px. */
const WIDTHS = [480, 768, 1080, 1400];
const DEFAULT_SIZES = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 640px";

export const Photo = ({ src, sizes = DEFAULT_SIZES, ...rest }) => {
  const responsive = /[?&]w=\d+/.test(src);
  const srcSet = responsive
    ? WIDTHS.map((w) => `${src.replace(/([?&])w=\d+/, `$1w=${w}`)} ${w}w`).join(", ")
    : undefined;
  return <img src={src} srcSet={srcSet} sizes={responsive ? sizes : undefined} {...rest} />;
};
